<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>

<div class="container">
    <div class="row align-items-center login-font flex-res r-form">
        <div class="card">
            <div class="row align-items-center">
                <div class="col-md-12 col-lg-6 p-0 rounded-0 border-0 login_background_image">
                    <div class="d-flex position-relative">
                        <img alt="" class="img-fluid w-100"
                            src="../../../../assets/images/favicon/Group 1000001671.png" />
                        <div class="position-absolute w-100 card-text-white">
                            <div class="card-body login-content">
                                <p class="join_hub">
                                    <span class="hub">The ultimate hub</span> for jobs and bookings in
                                    education
                                </p>
                                <div class="d-flex mt-20">
                                    <p class="txt-regular fs-16 class-txt">New to ClassCover?</p>
                                    <a class="text-regular-medium fs-16  u_l  class-txt  ml-5"
                                        href="https://www.classcover.com.au/lets-make-sure-you-are-in-the-right-place/">
                                        <b>Get started</b>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <div class="">
                        <div class="register-form">
                            <div class="px-0 pt-5 mb-4">
                                <p class="text-center">
                                    <img alt="" class="r_image" src="assets/images/favicon/CClogoFINAL-02 1.png" />
                                </p>
                                @if(!showOtpInput) {
                                <p class="mt-30 txt-regular fs-18">Signup for a free teacher profile</p>
                                <div class="col-lg-12 mt-10">
                                    <div class="">
                                        <form [formGroup]="signUpForm" novalidate>
                                            <div class="col-lg-12">
                                                <label for="username" id="username_label">Email</label>
                                                <input type="text" id="username" aria-labelledby="username_label"
                                                    ariaLabel="enter user name" id="username"
                                                    class="form-control input-sm  chat-input" formControlName="email"
                                                    placeholder="Type email" />
                                                <div *ngIf="signUpForm.get('email')?.touched && signUpForm.get('email')?.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="signUpForm.get('email')?.errors?.['required']">Email is
                                                        required.</div>
                                                    <div *ngIf="signUpForm.get('email')?.errors?.['email']">Invalid
                                                        email
                                                        format.</div>
                                                    <!-- QLD email not allowed -->
                                                    <div
                                                        *ngIf="signUpForm.get('email')?.touched && signUpForm.get('email')?.errors?.['qedQldEmailNotAllowed']">
                                                        QLD email addresses are not allowed
                                                    </div>
                                                </div>
                                                <div *ngIf="emailExistsError" class="text-danger">{{ emailExistsError }}
                                                    <a *ngIf="showLoginBtn" href="/login" aria-label="Login" appFocus
                                                        appClick
                                                        class="fs-12 text-regular-medium clr-cc-vilot u_l">Login</a>
                                                </div>

                                            </div>
                                            <div class="col-lg-12 mt-10">
                                                <label for="confirm-email" id="confirm_email_label">Confirm
                                                    email</label>
                                                <input type="email" id="confirm-email"
                                                    aria-labelledby="confirm_email_label"
                                                    ariaLabel="enter confirm email"
                                                    class="form-control input-sm chat-input"
                                                    formControlName="confirm_email" placeholder="Type confirm email" />

                                                <!-- Show required error -->
                                                <div *ngIf="signUpForm.get('confirm_email')?.touched && signUpForm.get('confirm_email')?.errors?.['required']"
                                                    class="text-danger">
                                                    Confirm email is required.
                                                </div>

                                                <!-- Show match error (from custom validator) -->
                                                <div *ngIf="signUpForm.errors?.['emailMismatch'] && signUpForm.get('confirm_email')?.touched"
                                                    class="text-danger">
                                                    Emails do not match.
                                                </div>
                                            </div>
                                            <div class="col-lg-12 mt-10">
                                                <label for="phone-number" id="phone_number_label">Phone number</label>
                                                <input type="text" id="phone-number"
                                                    aria-labelledby="phone_number_label" ariaLabel="enter phone number"
                                                    class="form-control input-sm chat-input" formControlName="phone"
                                                    placeholder="Type phone number" />
                                                <div *ngIf="signUpForm.get('phone')?.touched && signUpForm.get('phone')?.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="signUpForm.get('phone')?.errors?.['required']">
                                                        Phone number is required.
                                                    </div>
                                                    <div *ngIf="signUpForm.get('phone')?.errors?.['phoneAllowedChars']">
                                                        Only numbers and + are allowed.
                                                    </div>
                                                    <div *ngIf="signUpForm.get('phone')?.errors?.['phoneDigits']">
                                                        Enter a valid phone number
                                                    </div>
                                                </div>
                                                <span class="txt-regular fs-12">(+61 412345678)</span>
                                            </div>
                                            <div class="col-lg-12 mt-10">
                                                <label for="userPassword" id="password_label">Password</label>
                                                <div class="input-group showPassIcon">
                                                    <input [type]="showPassword ? 'text' : 'password'" id="userPassword"
                                                        aria-labelledby="password_label" ariaLabel="enter password"
                                                        class="form-control input-sm chat-input showPassRadius"
                                                        formControlName="password" placeholder="Type password" />
                                                    <button type="button" class="input-group-text"
                                                        (click)="togglePassword()" style="cursor: pointer;">
                                                        <i class="bi"
                                                            [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                                                    </button>
                                                </div>
                                                <div *ngIf="signUpForm.get('password')?.touched && signUpForm.get('password')?.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="signUpForm.get('password')?.errors?.['required']">
                                                        Password is
                                                        required.</div>
                                                    <div *ngIf="signUpForm.get('password')?.errors?.['minlength']">
                                                        Password must
                                                        be at least 8 characters.</div>
                                                    <div
                                                        *ngIf="!signUpForm.get('password')?.errors?.['minlength'] && signUpForm.get('password')?.errors?.['pattern']">
                                                        Required one number, special character, uppercase and lowercase.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 mt-10">
                                                <label for="confirm_password" id="confirm_password_label">Confirm
                                                    Password</label>
                                                <div class="input-group">
                                                    <input [type]="showRePassword ? 'text' : 'password'"
                                                        id="confirm_password" aria-labelledby="confirm_password_label"
                                                        ariaLabel="enter confirm password"
                                                        class="form-control input-sm chat-input showPassRadius"
                                                        formControlName="confirm_password"
                                                        placeholder="Type confirm password" />
                                                    <button type="button" class="input-group-text"
                                                        (click)="toggleRePassword()" style="cursor: pointer;">
                                                        <i class="bi"
                                                            [ngClass]="showRePassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                                                    </button>
                                                </div>
                                                <!-- Show required error -->
                                                <div *ngIf="signUpForm.get('confirm_password')?.touched && signUpForm.get('confirm_password')?.errors?.['required']"
                                                    class="text-danger">
                                                    Confirm password is required.
                                                </div>

                                                <!-- Show match error (from custom validator) -->
                                                <div *ngIf="signUpForm.errors?.['passwordMismatch'] && signUpForm.get('confirm_password')?.touched"
                                                    class="text-danger">
                                                    Passwords do not match.
                                                </div>
                                            </div>
                                            <div class="row mt-10">
                                                <div class="col-lg-12">
                                                    <div class="d-flex">
                                                        <div>
                                                            <input id="is_terms_accepted"
                                                                aria-labelledby="is_terms_accepted_label"
                                                                type="checkbox" formControlName="is_terms_accepted"
                                                                class="form-check-input" />
                                                        </div>
                                                        <div>
                                                            <label for="is_terms_accepted" id="is_terms_accepted_label"
                                                                class="ml-5 txt-regular m-0 mt-4">
                                                                I agree to the
                                                                <a class="reg-Link text-regular-medium" target="_blank"
                                                                    href="https://www.classcover.com.au/terms-and-conditions/">Terms
                                                                    and Conditions</a>
                                                                and
                                                                <a class="reg-Link text-regular-medium" target="_blank"
                                                                    href="https://www.classcover.com.au/privacy-policy/">Privacy
                                                                    Policy</a>.
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="signUpForm.get('is_terms_accepted')?.touched && signUpForm.get('is_terms_accepted')?.invalid"
                                                        class="text-danger">
                                                        You must agree to the Terms and Conditions.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-15">
                                                <form [formGroup]="signUpForm" (ngSubmit)="signUpVerify()" novalidate>
                                                    <button type="submit" aria-label="Login"
                                                        class="btn w-100 cc_p_btn fs_13">
                                                        Signup
                                                    </button>
                                                </form>
                                            </div>
                                        </form>
                                    </div>
                                    <p class="clr-grey-3 txt-regular fs-16 c-p mt-20 text-center">
                                        I already have an account?
                                        <a role="button" aria-label="Login" href="/login"
                                            class="text-regular-medium fs-16 clr-cc-vilot u_l c-p" appFocus appClick>
                                            Login</a>
                                    </p>
                                </div>
                                }
                                @if(showOtpInput) {
                                <div class="mt-10">
                                    <p class="mt-30 txt-regular fs-16">Verify your email</p>
                                    <p class="mt-16 txt-regular fs-14">
                                        Enter the 6-digit code sent to <span
                                            class="text-regular-bold">{{userEmail}}</span> to complete creating your
                                        ClassCover account. This code expires
                                        in <span class="text-regular-bold">{{expiryTime}} minutes</span>.</p>
                                    <div class="mt-16">
                                        <form>
                                            <div class="d-flex justify-content-between gap-2 flex-wrap otp-row">
                                                <input id="otp-input-0" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[0]"
                                                    (keyup)="onDigitInput($event, 0)" (input)="onOtpChange(0, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit0 />
                                                <input id="otp-input-1" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[1]"
                                                    (keyup)="onDigitInput($event, 1)" (input)="onOtpChange(1, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit1 />
                                                <input id="otp-input-2" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[2]"
                                                    (keyup)="onDigitInput($event, 2)" (input)="onOtpChange(2, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit2 />
                                                <input id="otp-input-3" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[3]"
                                                    (keyup)="onDigitInput($event, 3)" (input)="onOtpChange(3, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit3 />
                                                <input id="otp-input-4" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[4]"
                                                    (keyup)="onDigitInput($event, 4)" (input)="onOtpChange(4, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit4 />
                                                <input id="otp-input-5" maxlength="1"
                                                    [ngModelOptions]="{standalone: true}" type="text" pattern="[0-9]*"
                                                    inputmode="numeric" class="otp-box" [(ngModel)]="otp[5]"
                                                    (keyup)="onDigitInput($event, 5)" (input)="onOtpChange(5, $event)"
                                                    (paste)="$event.preventDefault()" autocomplete="one-time-code"
                                                    #digit5 />
                                            </div>
                                            <div class="text-end mt-10">
                                                <span *ngIf="!canResendOtp" class="fs-12">Resend code after
                                                    {{ otpTimer }}</span>
                                                <a *ngIf="canResendOtp" class="resend-otp-link"
                                                    (click)="resendEmailOtp()">Resend code</a>
                                            </div>

                                            <div *ngIf="otpError" class="otp-error">{{ otpError }}</div>
                                            <div class="mt-25">
                                                <!-- <div
                                                    class="mfa-card d-flex align-items-center justify-content-between p-3 mt-20">

                                                    <div class="d-flex align-items-center gap-3">

                                                        <div
                                                            class="icon-box d-flex align-items-center justify-content-center">
                                                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                                                <path
                                                                    d="M12 2L4 6V11C4 16 7.5 20.5 12 22C16.5 20.5 20 16 20 11V6L12 2Z"
                                                                    stroke="white" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>

                                                        <div>
                                                            <h6 class="mb-1 fw-semibold">Enable Multi-Factor
                                                                Authentication
                                                            </h6>
                                                            <small class="text-muted">Add an extra layer of
                                                                security</small>
                                                        </div>

                                                    </div>
                                                    <div class="form-check form-switch p-0">

                                                <input type="checkbox" role="switch" id="mfa-toggle"
                                                    aria-label="Enable Multi-Factor Authentication"
                                                    class="form-check-input delay-send form__switch_cc ml-0 c-p"
                                                    [(ngModel)]="isMfaEnabled" name="turnOnTeacherPortfolio"
                                                    (change)="onToggleChange($event)" />
                                            </div>
                                    </div> -->
                                                <button [disabled]="!verifyBtnDisable" type="submit" aria-label="Login"
                                                    (click)="submitEmailVerification()"
                                                    class="btn w-100 cc_p_btn fs_13 mt-20">
                                                    Verify
                                                </button>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                                <div class="mt-20">
                                    <div class="d-flex justify-content-center gap-5 flex-wrap mail-links">
                                        <div class="mb-2 mb-md-0">
                                            <a target="_blank" href="https://mail.google.com" class="txt-regular">
                                                <img alt="" class="mail_logo"
                                                    src="assets/images/side-nav/gmailLogo.svg" />
                                                Open Gmail
                                            </a>
                                        </div>
                                        <div>
                                            <a target="_blank" href="https://outlook.live.com" class="txt-regular">
                                                <img alt="" class="mail_logo"
                                                    src="assets/images/side-nav/outlookLogo.svg" />
                                                Open Outlook
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <p class="txt-regular mt-20 text-center">
                                    Can’t find your code? Check your spam folder!
                                </p>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>